import CircleType from 'circletype';

export default class DynamicThreeLayeredText {
  constructor(section) {
    this._initCurvedText(section);
  }

  _initCurvedText(section) {
    const text = section.el.querySelector('.rotated-text');
    const circleType = new CircleType(text);
    circleType.radius(280);
  }
}
